module.exports = __webpack_public_path__ + "static/media/02.29b7bad2.jpg";